import { FC } from 'react';
import { IconButton } from '../iconButton';
import plusIcon from 'assets/icons/plus.svg';
import plusWhiteIcon from 'assets/icons/plus-white.svg';
import { MAIN_COLOR } from 'shared/consts';

interface PlusIconButtonProps {
	onClick: () => void;
	backgroundMain?: boolean;
	hide?: boolean;
	light?: boolean;
	disableTouch?: boolean;
}

export const PlusButton: FC<PlusIconButtonProps> = ({
	onClick,
	backgroundMain = false,
	light = false,
	hide = false,
	disableTouch = false,
}) => {
	return (
		<IconButton 
      role="plus-button" 
      iconSrc={light ? plusWhiteIcon : plusIcon} 
      onClick={onClick} 
      hide={hide}
      disableTouch={disableTouch}
      styles={{
        background: backgroundMain ? MAIN_COLOR : 'transparent',
      }}
    />
	);
};
